var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"technical"},[_vm._v(" 高德信息重视人才的培养，努力为员工提供良好的工作环境和奖励机制，给予员工充分的发挥空间来激发创造力，让员工与企业共同成长，在工作中不断实现自身价值以获得个人满足感。 ")])}
var staticRenderFns = []

export { render, staticRenderFns }